module.exports = __webpack_public_path__ + "static/media/leadx.85756989.apk";